<div class="modal-header">
  <h4 class="modal-title">Soporte al Cliente</h4>
  <div class="mr-1">
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body">
  <div *ngIf="isCustomSupportContent" [innerHTML]="sanitizedContent"></div>

  <app-support-card
    *ngIf="!isCustomSupportContent"
    [customSupportChannels]="customSupportChannels"
    [companyLogo]="companyLogo"
    (channelClick)="openChannel($event)"
  >
  </app-support-card>

  <div
    class="text-center text-muted"
    *ngIf="!customSupportContent && !hasActiveChannels"
  >
    <i class="fa-solid fa-info-circle mb-2" style="font-size: 2rem"></i>
    <p>No hay información de soporte disponible.</p>
  </div>
</div>
